<template>
    <div></div>
</template>

<script>
    export default {
        name: 'help',
        babylonState: {
            moveCamera: [-8.9, 1.25,10,12,.5,0],

            explosion: true,


            Geo_Tschernobyl: {
                children: {
                    
                BG_Sphere: true,

                Geo_Neuer_Sarkophag_endpos: true,
                Geo_Schattenplane_NSC: true,


                Geo_Textur1_Reaktor_4_Damage: false,
                Geo_Textur1_Reaktor_4_Damage_Aussen: false,
                Geo_Textur1_Reaktor_4_Damage_Innen: false,

                Geo_Beton_Sarkophag_Rost: true,
                Geo_Schattenplane_Betonsarkophag: true,

                Geo_GrosserTurm_Gestaenge1: false,
                Geo_GrosserTurm_Schlot1: false,
                Geo_GrosserTurm_RoteStreifen1: false,
                Geo_GrosserTurm_Schattenplane: false,

                Geo_KleinerTurm_Geruest1: true,
                Geo_KleinerTurm_RoteStreifen1: true,
                Geo_KleinerTurm_Schlot1: true,
                Geo_KleinerTurm_Schattenplane: true,

                Geo_Sperrzone: false,

                    
                },
            },
        },

        babylonReady: function ()
        {
        //this.$audioController.initTrack('background', require('./../assets/audio/Geigerzaehler.mp3'), true, true),
        this.$babylonController.setAutoRotateBehaviour(false),
        this.$babylonController.setCameraRadiusLimit (5,40),
        this.$babylonController.zoomCamera(1.65);
        },

        mounted ()
        {
            // Hilfe Ansicht öffnen beim nächsten Tick, da sonst eventuell das 'currentPage' Event noch nicht
            // gefeuert hat und die Hilfe sonst wieder schließt.
            this.$nextTick(() =>
            {
                this.$eventBus.$emit('help.toggle');
            });
        },
    }

</script>

<style lang="scss">

</style>